import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import "@/index.css";
import App from "@/App";
import { registerServiceWorker } from "@/lib/pwa/registerServiceWorker";
import { initLiveUpdate } from "@/lib/liveUpdate";
import { hydrateAuthTokens } from "@/lib/tokenStore";

// On native (Capacitor) we must restore the durable session tokens from
// @capacitor/preferences into localStorage BEFORE React mounts, so the very
// first getMe() on cold start carries the token and the user stays logged in.
// On web this resolves instantly as a no-op.
async function bootstrap() {
  try {
    await hydrateAuthTokens();
  } catch {
    /* never block boot on storage */
  }

  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(
    <React.StrictMode>
      <HelmetProvider>
        <App />
      </HelmetProvider>
    </React.StrictMode>,
  );

  // Boot the service worker AFTER React mounts so the first paint isn't
  // delayed by SW install work. Registration itself is a no-op in dev.
  registerServiceWorker();

  // Capawesome Live Update (OTA): clears the rollback timer via ready() ASAP.
  // Native-only; a no-op on web. Background update checks are handled natively.
  initLiveUpdate();
}

bootstrap();
